import React from 'react';
import '../component/product_card.scss';
import { cartIcon, cartAdded, signal_half, signal_full } from '../../../assets';
import { ReactComponent as CartAdded } from '../../../assets/cartAdded.svg';

import { cartAddedG, signal4, fb_blue } from '../../../assets'
import { Stack } from '@mui/material';

type Product = {
  _id: string;
  type: string;
  is_purchased: number;
  name: string;
  category: string[];
  price: number;
  discount_price: number;
  audience_size: string;
  image_url: string;
};

type ProductCardProps = {
  product: Product;
  isInCart: boolean;
  addToCart: (product: Product) => void;
  activeTab: string;
};
const highlightedAudience :string[]= ["674eded6bd37f07c7eca8742","674efba024532c7482b3dbda"]
const ProductCard: React.FC<ProductCardProps> = ({ activeTab, product, isInCart, addToCart }) => {
  const isPurchased = product.is_purchased === 1;
  const formatAudienceSize = (size: number) => {
    if (size >= 10000000) {
      // Format as millions (10M+)
      return Math.floor(size / 1000000) + ' Million'; // Millions without decimals
    } else if (size >= 100000) {
      // Format as lakhs (1L+)
      return Math.floor(size / 100000) + ' Lakhs'; // Lakhs without decimals
    } else if (size >= 1000) {
      // Format as thousands (1K+)
      return Math.floor(size / 1000) + ' K'; // Thousands without decimals
    } else {
      // Return the number as is
      return size.toString();
    }
  };



  return (
    <>
    
    <div className="product-card" style={{position : "relative"}}>
      
      <div style={{ justifyContent: 'space-around', display: 'flex' }}>
        <div className="product-image" style={{
          background : `url(${product.image_url})`
        }}>
        </div>
        <div style={{ textAlign: 'justify' }}>
          <Stack direction={"row"} justifyContent={"space-between"}>
          <h3>
            <a className="p-title" href={product.image_url} target="_blank" rel="noopener noreferrer" style={{
              color : highlightedAudience.includes(product?._id) ? "red" : ""
            }}>
              {product.name}
            </a>
          </h3>
          {(activeTab== "All" && product.type == "Starter") && <img src={signal_half} style={{height:"15px", display :"inline-block", width:"30px", marginLeft : "10px"}}/>}
          {(activeTab== "All" && product.type == "Growth") && <img src={signal_full} style={{height:"15px", display :"inline-block", width:"30px", marginLeft : "10px"}}/>}
          </Stack>
          <p className="p-names">{product.category.join(' | ')}</p>

          <p>
            <span className="audience-label">Audience Size: </span>
            <span className="audience-value">
              {formatAudienceSize(Number(product.audience_size))}
            </span>

          </p>

        </div>
      </div>

      <div style={{ justifyContent: 'space-between', display: 'flex' }}>
        <div style={{ paddingTop: '18px' }}>
          <p className="price">
            {product.discount_price === 0 ? (
              <>
                <span className="original-price">₹{product.price}</span> {"Free"}
              </>
            ) : (
              <>
                <span className="original-price">₹{product.price}</span> ₹{product.discount_price}
              </>

            )}

          </p>

        </div>
        <div>
          <button
            className={isPurchased ? 'button-purchased' : 'button-default'}
            onClick={() => addToCart(product)}
            disabled={isPurchased} // Disable the button if the product is already purchased
          >
            {isPurchased ? (
              <img
                src={cartAddedG}
                alt="Cart Icon"
                style={{ width: '20px', marginRight: '8px' }} // Space between icon and text
              />
            ) : (
              <img
                src={isInCart ? cartAdded : fb_blue}
                alt="Cart Icon"
                style={{ width: '20px', marginRight: '8px' }} // Space between icon and text
              />
            )}
            <span
              className={isPurchased ? 'button-text-purchased' : ''}
              style={{
                color: isPurchased ? 'green' : (isInCart ? 'black' : 'black'), // Text color logic for inline fallbacks
              }}
            >
              {isPurchased ? 'Purchased' : isInCart ? 'Selected' : 'Share to Facebook'}
            </span>
          </button>


        </div>
      </div>
    </div>
    </>
  );
};

export default ProductCard;
